import { Account } from '@modules-deprecated/app/accounts/types'
import { Currency } from '@modules-deprecated/app/currencies/types'

import { BankAccount } from '../types/bankAccount'

interface ConvertToBaseCurrencyProps {
  amount: number
  sourceCurrencyId: string
  baseCurrencyId: string
  currencyRateMap: Map<string, number>
}

interface GetAccountsTotalBalanceProps {
  activeAccounts: Account[]
  bankAccountsByAccountId: Map<string, BankAccount>
  currencies?: Currency[] | null
  baseCurrencyId: string
}

const convertToBaseCurrency = ({
  amount,
  sourceCurrencyId,
  baseCurrencyId,
  currencyRateMap,
}: ConvertToBaseCurrencyProps): number => {
  if (sourceCurrencyId === baseCurrencyId) {
    return amount
  }

  const sourceRate = currencyRateMap.get(sourceCurrencyId)
  const targetRate = currencyRateMap.get(baseCurrencyId)

  if (!sourceRate || !targetRate || targetRate === 0) {
    return 0
  }

  return amount * (sourceRate / targetRate)
}

export const getAccountsTotalBalance = ({
  activeAccounts,
  bankAccountsByAccountId,
  currencies,
  baseCurrencyId,
}: GetAccountsTotalBalanceProps): number => {
  if (!activeAccounts) {
    return 0
  }

  const currencyRateMap = new Map((currencies ?? []).map((c) => [c.id, c.exchangeRate]))

  const total = activeAccounts.reduce((sum, account) => {
    const bankAccount = bankAccountsByAccountId.get(account.id)

    if (bankAccount?.bookedBalance) {
      return (
        sum +
        convertToBaseCurrency({
          amount: bankAccount.bookedBalance.value,
          sourceCurrencyId: bankAccount.bookedBalance.currency,
          baseCurrencyId,
          currencyRateMap,
        })
      )
    }

    return sum
  }, 0)

  return Math.round(total * 100) / 100
}
